export enum GroupType {
  Admin = 1,
  Customer = 2,
  PomAgencyMember = 6,
  PomAgency = 7,
  PomRepresentative = 8,
}

export const pomGroupTypes = [
  GroupType.Admin,
  GroupType.Customer,
  GroupType.PomAgency,
  GroupType.PomAgencyMember,
  GroupType.PomRepresentative,
];

export const isAgencyGroup = (types: GroupType[]): boolean => {
  return [GroupType.PomAgency].some((type) => types.includes(type));
};

export const isRepresentativeGroup = (types: GroupType[]): boolean => {
  return [GroupType.PomRepresentative].some((type) => types.includes(type));
};

export const isDebtorGroup = (types: GroupType[]): boolean => {
  return [GroupType.Customer].some((type) => types.includes(type));
};

export const isPomGroup = (type: GroupType | undefined) => {
  return type && pomGroupTypes.includes(type);
};
